import {
  COMMENT_POP,
  COMMENT_POP_UPDATE,
  NOTICE,
  NOTICEDETAIL,
  NOTICEHIT,
  NOTICEURGENT
} from 'src/redux/actions/actionTypes';


let noticeData = [];

export const mainNoticeReducer = (state = noticeData, action) => {
  switch (action.type) {

    case NOTICE:
    case NOTICEDETAIL:
    case NOTICEHIT:
    case NOTICEURGENT:
    case COMMENT_POP:
    case COMMENT_POP_UPDATE:

      /* Login success */
      noticeData.splice(0, noticeData.length);
      // console.log("test",action.payload.data)
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        noticeData.push(action.payload.data.res);
        return noticeData;
      }
      return state;

    default:
      return state;
  }
};
  
  